import { Button } from "antd";

export const ButtonUpVoucherAndPrint = ({ record }) => {
  return (
    <div>
      <Button type="primary">{"Lập chứng từ & In phiếu"}</Button>
    </div>
  );
};
